import styled from 'styled-components';

import { flexContainer } from '@dreryk/react-components';

import { PRESCRIPTION_ISSUING_RIGHT_PANEL_WIDTH } from './prescriptionIssuingPanel.constants';

const StyledPrescriptionIssuingRightPanel = styled.div`
   ${flexContainer};
   min-width: ${PRESCRIPTION_ISSUING_RIGHT_PANEL_WIDTH};
   max-width: ${PRESCRIPTION_ISSUING_RIGHT_PANEL_WIDTH};
   flex-direction: column;
   height: 100%;
`;

StyledPrescriptionIssuingRightPanel.displayName = 'StyledPrescriptionIssuingRightPanel';

export { StyledPrescriptionIssuingRightPanel };
